export const mockedParams = {
  lang: 'fr',
  csrfToken: 'fc809ce5a8d3b9dd954ee3eb31cf9999163269da-1530174519223-6ca66c70304f0e5b46d34a38',
  connected_user: {
    "id": "5e473e34-6df9-45ef-9290-fef55f74c4dc",
    "created_at": "2018-11-07T14:50:58Z",
    "email": "remy.poirier92@gmail.com",
    "first_name": "remy",
    "last_name": "poirier",
    "avatar_url": "/assets/images/avatar-empty-160x160.png",
    "birthday": "1992-09-06T22:00:00Z",
    "phone": "0781573346",
    "main_phone": "0781573346",
    "has_been_claimed": true,
    "address": {
      "zip": "92150",
      "city": "Suresnes",
      "country": "FR"
    },
    "custom": {
      "ips": [
        {
          "date": "2018-11-07 15:50:58.203+0100",
          "ip": "127.0.0.1",
          "action": "signin"
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/conf/params-mock.ts